import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getRequestFeedbackDetails.operation = 'READ';
getRequestFeedbackDetails.byId = true;
export function getRequestFeedbackDetails(id) {
    return get(`${API_URL}/feedback/request/details/` + id);
}
